import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Helmet from 'react-helmet';
import { withRouter } from 'react-router-dom';
import { COLORS } from '@client/shared/js/Colors';
import { strings } from '@client/localization/Localization';

/*
 * Should be called when title, meta tags, etc... have to be updated according to received JSON data.
 */

class GenericHelmet extends PureComponent {
  render() {
    const { helmetData } = this.props;
    let meta = [
      {
        name: 'description',
        content: strings.generalDescription,
      },
      {
        property: 'og:url',
        content: 'https://factuals.com',
      },
      {
        property: 'og:locale',
        content: 'sv_SE',
      },
      {
        property: 'og:type',
        content: 'website',
      },
      {
        property: 'og:title',
        content: strings.ogTitle,
      },
      {
        property: 'og:description',
        content: strings.ogDescription,
      },
      {
        property: 'og:site_name',
        content: strings.generalTitle,
      },
      {
        name: 'twitter:card',
        content: 'summary',
      },
      {
        name: 'twitter:description',
        content: strings.twitterDescription,
      },
      {
        name: 'twitter:title',
        content: strings.twitterTitle,
      },
      {
        name: 'theme-color',
        content: COLORS.colorToolbar,
      },
    ];

    let receivedMeta = helmetData && helmetData.meta;
    if (receivedMeta) {
      for (let i = 0; i < receivedMeta.length; i++) {
        const currentData = receivedMeta[i];
        const alreadyMetaDataWithName = meta.find((element) => {
          return (
            (element.name && element.name === currentData.name) ||
            (element.property && element.property === currentData.property)
          );
        });
        if (alreadyMetaDataWithName) {
          alreadyMetaDataWithName.content = currentData.content;
        } else {
          meta.push(currentData);
        }
      }
    }

    return <Helmet title={helmetData && helmetData.title} meta={meta} />;
  }
}

GenericHelmet.propTypes = {
  helmetData: PropTypes.shape({
    title: PropTypes.string,
    meta: PropTypes.array,
  }),
};

export default withRouter(GenericHelmet);
